// Redirect to previous page or homepage and open cart drawer
(function() {
  var referrer = document.referrer;
  var currentHost = window.location.host;

  // If referrer is from the same site, go back; otherwise go to homepage
  if (referrer && referrer.includes(currentHost) && !referrer.includes('/cart')) {
    window.location.href = referrer;
  } else {
    window.location.href = '/';
  }

  // Store flag to open cart drawer after redirect
  sessionStorage.setItem('openCartDrawer', 'true');
})();
